import { useEffect } from 'react';

interface IUseOnClickOutSideParams {
	disableClickOutside?: boolean;
	fireEvent?: 'click' | 'mousedown' | 'mouseup' | 'dblclick' | 'contextmenu';
	handler: (_e: any) => void;
	refs: any[];
	triggerMouseButton?: number;
}

export function useOnClickOutside({
	disableClickOutside,
	fireEvent = 'mousedown',
	handler,
	refs,
	triggerMouseButton,
}: IUseOnClickOutSideParams): void {
	useEffect(
		() => {
			const filteredArrayOfRef = refs.filter((ref: any) => ref.current);

			if (filteredArrayOfRef.length) {
				const listener = (e: any) => {
					if (!filteredArrayOfRef) return;

					const isRefClicked = filteredArrayOfRef.some(({ current }: any) =>
						!current || current?.contains(e.target));

					if (isRefClicked || disableClickOutside) return;

					if (triggerMouseButton) {
						if (e.which === triggerMouseButton) handler(e);
					} else {
						handler(e);
					}
				};

				document.addEventListener(fireEvent, listener);
				document.addEventListener('touchstart', listener);

				return () => {
					document.removeEventListener(fireEvent, listener);
					document.removeEventListener('touchstart', listener);
				};
			}
		},
		[refs, handler, disableClickOutside, fireEvent, triggerMouseButton],
	);
}

export function useOnClickOutsideSelect(
	arrayOfRef: any[],
	handler: (_e: any) => void,
	isDisableClickOutside?: boolean,
	whichButton?: number,
): void {
	useEffect(
		() => {
			const listener = (e: any) => {
				const filteredArrayOfRef = arrayOfRef.filter((ref: any) => ref.current);

				if (!filteredArrayOfRef) return;

				const isRefClicked = filteredArrayOfRef.some(({ current }: any) =>
					!current || current?.contains(e.target));

				if (isRefClicked || isDisableClickOutside) return;

				if (whichButton) {
					if (e.which === whichButton) handler(e);
				} else handler(e);
			};

			document.addEventListener('mousedown', listener);
			document.addEventListener('touchstart', listener);

			return () => {
				document.removeEventListener('mousedown', listener);
				document.removeEventListener('touchstart', listener);
			};
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[arrayOfRef, handler, isDisableClickOutside],
	);
}

